





























































import { getParentRoute } from '@/router';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';
import { needProviderConnected } from '@/utils/provider';
import { needLaunchRewardsProgram } from '@/utils/start-guide';

import { Group } from '@/router/group.model';
import { Route } from '@/router/route.model';

import { ERouteDisclaimerMessage } from '@/router/validators/enums';

import InfoIcon from '@/components/icons/InfoV2.vue';

import UseLefBarDisclaimers from '../UseLefBarDisclaimers.vue';
import LeftBarNotificationArrow from '@/componentsV2/molecules/LeftBarNotificationArrow/LeftBarNotificationArrow.vue';
import RewardsModel from '@/componentsV2/templates/RewardsModel/RewardsModel.vue';
import { widgetIsActive } from '@/router/validators/utils';
import { IBusinessType } from '@/models/business';
import BillingModel from '@/views/Models/BillingModel.vue';
import eventBus from '@/utils/eventBus';

@Component({ components: { InfoIcon, LeftBarNotificationArrow } })
export default class TopBarNavItem extends Mixins(
  UseLefBarDisclaimers,
  RewardsModel,
  BillingModel
) {
  @Prop(Route) readonly route!: Route;
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop(Boolean) readonly forceActive: boolean | undefined;
  @Prop({ default: false }) mobileTabs?: boolean;
  @Prop() group!: Group;
  @Prop() focused?: boolean;
  @Prop() notification?: any;

  active = false;
  disabled = false;
  disclaimer?: string = '';
  menuTooltipOffset = {
    top: 0,
    left: 0
  };

  menuNotificationOffset = {
    top: 0,
    left: 0
  };

  get isMobileDevice() {
    return isMobile();
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get title() {
    if (!this.route.meta.navbar || !this.route.meta.navbar.name) return '';
    return this.route.meta.navbar.name;
  }

  get isOnlineOnly() {
    return this.businessInfo.type === IBusinessType.ONLINE;
  }

  get loyaltyRewardsText() {
    if (this.businessInfo.type === IBusinessType.INSTORE)
      return 'Loyalty Rewards Program';

    return 'Online Loyalty Rewards Program';
  }

  get needLaunchRewardsProgram() {
    return needLaunchRewardsProgram(true, this.route.path);
  }

  get loyaltyWidgetBlocked() {
    return this.route.name === 'settings-widget' && !widgetIsActive();
  }

  get sellCoinsBlocked() {
    return (
      this.route.name === 'sell_coins' && this.isOnlineOnly && !widgetIsActive()
    );
  }

  get blocked() {
    const routesCantBeBlocked = [
      'refund_return_policy',
      'manage_loyalty',
      'program-status'
    ];

    return (
      needProviderConnected(this.route) ||
      this.loyaltyWidgetBlocked ||
      this.sellCoinsBlocked ||
      (this.needLaunchRewardsProgram &&
        !routesCantBeBlocked.includes(this.route.name))
    );
  }

  get screenSmall() {
    return window.innerWidth <= 1280;
  }

  onClickRewardProgram() {
    if (this.inactiveBilling) {
      this.$router.push(this.route.path);
      setTimeout(() => {
        eventBus.$emit('upgradeBillingEmptyState');
      }, 300);
      return;
    }
    this.launchRewardsProgram();
  }

  getTranslatedDisclaimer(disclaimerKey: ERouteDisclaimerMessage) {
    if (!this.disclaimers[disclaimerKey]) return '';

    return this.disclaimers[disclaimerKey];
  }

  getTranslatedLabel(route: Route) {
    const translatedLabel = this.$t(`menus.sidebar.${route.name}`);

    if (!translatedLabel && route.meta.navbar) {
      return route.meta.navbar.name;
    }

    return translatedLabel;
  }

  async launchRewardsProgram() {
    if (this.businessInfo.type === IBusinessType.BOTH) {
      this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
        operationType: IBusinessType.ONLINE
      });
    }
    this.openRewardsProgramModal({
      operationType: this.businessInfo.operationType,
      feature: this.route.path
    });
  }

  setScrollPositionOnCenter() {
    if (window.innerWidth > 620) return;

    const tabElement = this.$refs[this.route.name] as HTMLElement;

    if (tabElement) {
      tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  }

  getMenuItemOffset(selector: string) {
    let { left, top, width, height } = this.$el.getBoundingClientRect();
    const el = this.$el.querySelector(selector) as HTMLElement;

    if (el) {
      const tooltipOffset = el.getBoundingClientRect();

      return {
        left: left + width,
        top: top + height / 2 - tooltipOffset.height / 2
      };
    }
    return { left: 0, top: 0 };
  }

  setMenuTooltipOffset() {
    this.menuTooltipOffset = this.getMenuItemOffset('.nav-item-disclaimer');
  }

  @Watch('notification')
  setMenuNotificationOffset() {
    if (!this.notification || this.notification.link !== this.route.path)
      return;

    setTimeout(() => {
      this.menuNotificationOffset = this.getMenuItemOffset(
        '.notification-arrow'
      );
    });
  }

  onClick(event: any) {
    event.preventDefault();

    const tabElement = this.$refs[this.route.name] as HTMLElement;
    const tabElementParent = tabElement.parentNode as HTMLElement;

    // remove html code from string
    const routeLabel =
      this.route.meta.navbar &&
      this.route.meta.navbar.name &&
      this.route.meta.navbar.name
        .replace(/<([^]+).*>.*?<\/([^]+)>/gi, '')
        .replace(/ +(?= )/g, '');

    this.$analytics({
      eventCategory: 'leftbar-nav',
      eventAction: 'click',
      eventLabel: routeLabel
    });

    if (tabElement && tabElementParent) {
      const tabElementInfos = tabElement.getBoundingClientRect() as DOMRect;
      const tabElementParentInfos = tabElementParent.getBoundingClientRect() as DOMRect;

      if (tabElementInfos && tabElementParentInfos) {
        const offset = tabElementParentInfos.width - tabElementInfos.width;

        if (tabElementInfos.x > offset || tabElementInfos.x < 12) {
          this.setScrollPositionOnCenter();
        }
      }
    }

    if (this.disabled || this.viewOnly) {
      return false;
    }

    const { path } = this.route;

    if (path) {
      this.$router.push(path);
      this.$emit('click-route', this.route.name);
    }
  }

  @Watch('$route')
  onRouteChange() {
    const parentRoute = getParentRoute();

    this.active = !!(
      this.forceActive ||
      (parentRoute && parentRoute.path === this.route.path)
    );
  }

  mounted() {
    const parentRoute = getParentRoute();

    const isActive =
      this.forceActive || (parentRoute && parentRoute.path === this.route.path);

    this.active = !!isActive;

    if (isActive) this.setScrollPositionOnCenter();

    this.disclaimer =
      this.route.meta.navbar && this.route.meta.navbar.description;
  }
}
